module.exports = __webpack_public_path__ + "img/tjsb.27bc3799.png";